import { Image, Link, Text, View } from '@react-pdf/renderer';

import Hand from '@assets/icons/hand-min.png';
import { PublicEventDetailsResponse } from '@hubs101/booking-api-skd-client/lib/types';
import { globalStyles } from '@composites/PDF/AgendaPdfContent/styles';
import homeImage6 from '@assets/images/IoTW_Berlin_6.jpg';
import { styles } from '../../styles';
import { useTranslation } from 'react-i18next';

interface AttendeeListProps {
  event: PublicEventDetailsResponse;
}

const AttendeeList = ({ event }: AttendeeListProps) => {
  const { t } = useTranslation();
  return (
    <View style={{ ...styles.bodyContainer }}>
      <View style={styles.leftSideBody}>
        <Image
          style={{ width: 'auto', height: '100%', objectFit: 'cover' }}
          src={homeImage6}
        />
      </View>

      <View
        style={{
          ...styles.rightSideBody,
          gap: 20,
          justifyContent: 'flex-start',
          paddingTop: 55,
        }}
      >
        <Text style={{ ...styles.title, fontSize: 44, paddingLeft: 15 }}>
          {`${t('attendee-list')}*`}
        </Text>
        <View
          style={{
            ...globalStyles.lineBar,
            marginRight: 'auto',
          }}
        />
        <Text style={styles.attendeeListSubtitle}>
          {t('attendee-list-subtitle')}
        </Text>
        <View style={styles.buttonWrapper}>
          <Link
            style={{ textDecoration: 'none' }}
            src={`${window.location.origin}/events/${event?.slug}${t('community-url')}`}
          >
            <Text
              style={{
                ...styles.button,
                backgroundColor: event?.design?.themeColor ?? '#333333',
              }}
            >
              {t('to-the-attendee-list')}
            </Text>
          </Link>

          <Image style={styles.hand} src={Hand} />
        </View>
      </View>
    </View>
  );
};

export default AttendeeList;
